import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=a38ba3fe&scoped=true&"
import script from "./Detail.vue?vue&type=script&lang=js&"
export * from "./Detail.vue?vue&type=script&lang=js&"
import style0 from "./Detail.vue?vue&type=style&index=0&id=a38ba3fe&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38ba3fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2065084294/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a38ba3fe')) {
      api.createRecord('a38ba3fe', component.options)
    } else {
      api.reload('a38ba3fe', component.options)
    }
    module.hot.accept("./Detail.vue?vue&type=template&id=a38ba3fe&scoped=true&", function () {
      api.rerender('a38ba3fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Detail.vue"
export default component.exports